export default function description() {
    return (
        <div className="card__description-basic">
            <div className="card__description">
                <p className="card__description-text">
                    Агробіон — це високоефективне органічне добриво на основі гумату калію, збагачене амінокислотами та мікроелементами, яке покращує родючість ґрунту, активізує ґрунтову мікрофлору та стимулює інтенсивний розвиток рослин.
                </p>
                <p className="card__description-text">
                    Препарат працює як біологічний стимулятор росту рослин та відновлювач родючості ґрунту, допомагаючи покращити доступність поживних речовин і створити оптимальні умови для розвитку кореневої системи культур.
                </p>
                <p className="card__description-text">
                    Завдяки високому вмісту гумінових речовин добриво сприяє активізації природних біологічних процесів у ґрунті та підвищує ефективність використання поживних елементів рослинами.
                </p>
                <p className="card__description-title">
                    Дія препарату
                </p>
                <p className="card__description-text">
                    Внесення Агробіону у ґрунт забезпечує комплексний позитивний ефект:
                </p>
                <ul className="card__description-list">
                    <li className="card__description-numbering">
                        Покращує структуру ґрунту та підвищує його вологоутримуючу здатність.
                    </li>
                    <li className="card__description-numbering">
                        Збільшує буферність ґрунту, тобто здатність підтримувати оптимальний природний рівень pH, навіть при надходженні надлишкових кислотних або лужних сполук.
                    </li>
                    <li className="card__description-numbering">
                        Активує корисну мікрофлору ґрунту, що сприяє природному відновленню його родючості.
                    </li>
                    <li className="card__description-numbering">
                        Стимулює розвиток ґрунтових мікроорганізмів, які розкладають важкорозчинні сполуки фосфору та переводять їх у доступну для рослин форму.
                    </li>
                    <li className="card__description-numbering">
                        Покращує накопичення та утримання азоту в ґрунті, створюючи сприятливі умови для бактерій, що фіксують атмосферний азот.
                    </li>
                    <li className="card__description-numbering">
                        Підвищує доступність поживних речовин, оскільки гумати адсорбують мікроелементи та допомагають транспортувати їх до кореневої системи рослин.
                    </li>
                </ul>
                <p className="card__description-title">
                    Як працює гумат калію у добриві
                </p>
                <p className="card__description-text">
                    Основою препарату є гумат калію — природна органічна сполука, яка:
                </p>
                <ul className="card__description-list">
                    <li className="card__description-numbering">
                        стимулює активність ґрунтових бактерій
                    </li>
                    <li className="card__description-numbering">
                        покращує кореневе живлення рослин
                    </li>
                    <li className="card__description-numbering">
                        активізує процеси гуміфікації та відновлення ґрунту
                    </li>
                    <li className="card__description-numbering">
                        сприяє накопиченню доступних мікроелементів
                    </li>
                    <li className="card__description-numbering">
                        Під впливом препарату активізується мікробне співтовариство ґрунту, що дозволяє підвищити доступність поживних речовин і забезпечити рослини збалансованим живленням.
                    </li>
                </ul>
                <p className="card__description-title">
                    Норма внесення
                </p>
                <ul className="card__description-list">
                    <li className="card__description-numbering">
                        100–200 л/га — для більшості типів ґрунтів
                    </li>
                    <li className="card__description-numbering">
                        до 250 л/га — для піщаних та важких глинистих ґрунтів
                    </li>
                </ul>
                <p className="card__description-text">
                    Норма внесення може коригуватись залежно від типу ґрунту, рівня родючості та культури.
                </p>
            </div>
            <div className="card__description-preference">
                <div className="aside__title">Агрохімічні характеристики</div>
                <div className="aside__content">
                    <div className="aside-char">
                        <div className="aside-char__head">Потенціал врожайності</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--8">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">8</div>
                        </div>
                    </div>
                    <div className="aside-char">
                        <div className="aside-char__head">Стабільність урожаю</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--7">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">7</div>
                        </div>
                    </div>
                    <div className="aside-char">
                        <div className="aside-char__head">Енергія початкового росту</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--8">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">8</div>
                        </div>
                    </div>
                    <div className="aside-char">
                        <div className="aside-char__head">Ефективність</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--9">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">9</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
